export const homeSectionStruct = {
  wrap: "wrap",
  align: "center",
  justify: "center",
  style: {
    height: "100vh",
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
};
